import { useContext } from 'react';
import { AppContext } from '../context/Provider';

export default function Footer() {
    const { appVersion, langResources } = useContext(AppContext);

    return (
        <footer className='footer p-3'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-sm-6'>
                        <img
                            src='/assets/images/platec_light.png'
                            alt=''
                            width={100}
                        />
                    </div>

                    <div className='col-sm-6'>
                        <div className='text-sm-end d-none d-sm-block'>
                            {langResources['home.page']['title.web.page']}{' '}
                            {appVersion}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
